(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
if (!customElements.get('catex-blog-carousel')) {
 customElements.define('catex-blog-carousel', class extends HTMLElement {
  connectedCallback() {
   this.track = this.querySelector('.cj-carousel-track');
   this.slides = [...this.querySelectorAll('.cj-slide')];
   if (!this.track || this.slides.length < 2) return;
   this.abort = new AbortController();
   const options = { signal: this.abort.signal };
   this.previous = this.querySelector('[data-cj-prev]');
   this.next = this.querySelector('[data-cj-next]');
   this.current = this.querySelector('[data-cj-current]');
   this.index = 0;
   this.update = () => {
    const left = this.track.getBoundingClientRect().left;
    let nearest = 0, distance = Infinity;
    this.slides.forEach((slide, index) => {
     const gap = Math.abs(slide.getBoundingClientRect().left - left);
     if (gap < distance) { nearest = index; distance = gap; }
    });
    this.index = nearest;
    this.previous.disabled = nearest === 0;
    this.next.disabled = nearest === this.slides.length - 1;
    if (this.current.textContent !== String(nearest + 1)) this.current.textContent = String(nearest + 1);
   };
   this.move = (direction) => {
    const target = this.slides[Math.max(0, Math.min(this.slides.length - 1, this.index + direction))];
    const left = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
    this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
   };
   this.previous.addEventListener('click', () => this.move(-1), options);
   this.next.addEventListener('click', () => this.move(1), options);
   this.track.addEventListener('scroll', () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(this.update);
   }, { ...options, passive: true });
   this.observer = new ResizeObserver(this.update);
   this.observer.observe(this.track);
   this.querySelector('.cj-carousel-controls').hidden = false;
   this.setAttribute('data-ready', '');
   this.update();
  }
  disconnectedCallback() {
   this.abort?.abort();
   this.observer?.disconnect();
   cancelAnimationFrame(this.frame);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const paginationScrollKey = 'catex:collection-pagination-scroll';
  const resultsListId = 'ResultsList';

  const getPaginationDestination = (url) => {
    const destination = new URL(url, window.location.origin);
    return `${destination.pathname}?page=${destination.searchParams.get('page') ?? ''}`;
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const paginationLink = event.target.closest('results-list .pagination__link[href]');
      if (!(paginationLink instanceof HTMLAnchorElement)) return;

      try {
        sessionStorage.setItem(paginationScrollKey, getPaginationDestination(paginationLink.href));
      } catch {
        // The navigation still works if the browser blocks sessionStorage.
      }
    },
    { capture: true }
  );

  const scrollToCollectionProducts = () => {
    let shouldScroll = false;

    try {
      const storedDestination = sessionStorage.getItem(paginationScrollKey);
      shouldScroll = storedDestination === getPaginationDestination(window.location.href);
      sessionStorage.removeItem(paginationScrollKey);
    } catch {
      return;
    }

    if (!shouldScroll) return;

    const resultsList = document.getElementById(resultsListId);
    if (!resultsList) return;

    const header = document.getElementById('header-component');
    const headerOffset = header?.getBoundingClientRect().height ?? 0;
    const resultsTop = resultsList.getBoundingClientRect().top + window.scrollY;
    const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

    window.scrollTo({
      top: Math.max(0, resultsTop - headerOffset - 16),
      behavior: scrollBehavior,
    });
  };

  const restoreProductsPosition = () => {
    requestAnimationFrame(() => requestAnimationFrame(scrollToCollectionProducts));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreProductsPosition, { once: true });
  } else {
    restoreProductsPosition();
  }

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
